export const Questions = [
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child look at you in the eye when she wants something?",
        "question_type": "text",
        "question_order": 1,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child turn his/her head to look at you when you walk up and start talking to him/her?",
        "question_type": "text",
        "question_order": 2,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child turn his/her head to look at you when you call his or her name?",
        "question_type": "text",
        "question_order": 3,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child ever use your hand like a tool, grab it and place it on what she wants?",
        "question_type": "text",
        "question_order": 4,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child use simple gestures to direct your attention or to request something?",
        "question_type": "text",
        "question_order": 5,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child use words and gestures together?",
        "question_type": "text",
        "question_order": 6,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child show a range of facial expressions, e.g., does your child smile, frown, pout, raise his or her eyebrows in surprise?",
        "question_type": "text",
        "question_order": 7,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Do his/her facial expressions match the situation?",
        "question_type": "text",
        "question_order": 8,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child understand the expressions of other people's faces, e.g., when you frown or have an angry face, when you have a happy face?",
        "question_type": "text",
        "question_order": 9,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Will your child play imitative games such as pat-a-cake, peek-a-boo? Will your child cover his or her face to play peek-a-boo with you?",
        "question_type": "text",
        "question_order": 10,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child imitate you when you wave bye-bye, clap your hands for pat-a-cake or shake your head 'no'?",
        "question_type": "text",
        "question_order": 11,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Will your child imitate you when you are doing housework such as dusting, sweeping or cooking?",
        "question_type": "text",
        "question_order": 12,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Will your child play ball by rolling, kicking or throwing it back and forth?",
        "question_type": "text",
        "question_order": 13,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child make hand gestures or movements to familiar songs such as 'itsy-bitsy spider' or 'wheels on the bus'?",
        "question_type": "text",
        "question_order": 14,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child smile back at you when you smile at him or her?",
        "question_type": "text",
        "question_order": 15,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "In a new or disturbing situation, does your child look to you for comfort?",
        "question_type": "text",
        "question_order": 16,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child ask you questions, for example, about an object, a situation, or a person?",
        "question_type": "text",
        "question_order": 17,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child get stuck asking the same question over and over?",
        "question_type": "text",
        "question_order": 18,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Can your child take turns in a conversation?",
        "question_type": "text",
        "question_order": 19,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Will your child respond if other children talk to or try to play with him/her?",
        "question_type": "text",
        "question_order": 20,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child interested in making friends?",
        "question_type": "text",
        "question_order": 21,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child dress-up and 'make-believe' your child is someone or something else?",
        "question_type": "text",
        "question_order": 22,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child realize certain things your child does bother other children or adults?",
        "question_type": "text",
        "question_order": 23,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child understand when your child is being teased, bullied?",
        "question_type": "text",
        "question_order": 24,
        "question_weight": 5.00,
        "question_category": "Interpersonal Skills",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 4.00
            },
            {
                "option_text": "Rare",
                "option_weight": 3.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 2.00
            },
            {
                "option_text": "Often",
                "option_weight": 1.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child ever ask socially inappropriate questions, e.g., ask a personal question or make a personal statement at the wrong time?",
        "question_type": "text",
        "question_order": 25,
        "question_weight": 5.00,
        "question_category": "Problem Solving",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have trouble participating in groups (playing with at least 2 other children), for example, school projects or kids sports teams?",
        "question_type": "text",
        "question_order": 26,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child often say what you said right afterward (immediate echolalia)?",
        "question_type": "text",
        "question_order": 27,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z",
        "additional_description": "Examples include: flapping hands when excited, walking on toes, flicking fingers, spinning or rocking body, walking or pacing in a pattern"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have any physical mannerisms or odd way of moving his hands or his body that look the same each time?",
        "question_type": "text",
        "question_order": 28,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "additional_description": "Examples include: flapping hands when excited, walking on toes, flicking fingers, spinning or rocking body, walking or pacing in a pattern",
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have rigid rituals or routines that your child set up?",
        "question_type": "text",
        "question_order": 29,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have a markedly selective diet, eat the same few foods over and over and resist new foods?",
        "question_type": "text",
        "question_order": 30,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have a special interest in one toy or activity that is unusual in its intensity?",
        "question_type": "text",
        "question_order": 31,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child repeatedly activate toys that are shiny or light up, persist in staring at objects that spin such as a fan?",
        "question_type": "text",
        "question_order": 32,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child seem overly sensitive to touch, e.g., during dressing or bathing or just giving him or her a hug?",
        "question_type": "text",
        "question_order": 33,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child fixated on chewing on non-food items/ unusual objects such as arms of chairs or bed rails?",
        "question_type": "text",
        "question_order": 34,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child dislike wearing certain clothes?",
        "question_type": "text",
        "question_order": 35,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "additional_description": "Examples include: won't wear tight clothes, won't wear long or short sleeves, resists tags in clothes or seams in socks",
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child dislike teeth or hair brushing, having hair or face washed, haircuts or washing hair, fingernails or toenails cut?",
        "question_type": "text",
        "question_order": 36,
        "question_weight": 5.00,
        "question_category": "Sensory Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child bring toys very close to his/her face, look out of the side of his/her eyes or lay his/her head on the floor and look from the side at toys such as the wheels turning on a toy car?",
        "question_type": "text",
        "question_order": 37,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child easily become over stimulated, need to leave right away in loud crowded place?",
        "question_type": "text",
        "question_order": 38,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child easily distractible?",
        "question_type": "text",
        "question_order": 39,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child restless, not able to sit still; is he overly active?",
        "question_type": "text",
        "question_order": 40,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child have difficulty initiating or finishing tasks such as homework?",
        "question_type": "text",
        "question_order": 41,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child destructive to toys or other objects?",
        "question_type": "text",
        "question_order": 42,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child aggressive with siblings, peers or adults, e.g., hits or pushes?",
        "question_type": "text",
        "question_order": 43,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child's mood change abruptly for no apparent reason?",
        "question_type": "text",
        "question_order": 44,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does your child exhibit excessive temper tantrums and have difficulty in calming down?",
        "question_type": "text",
        "question_order": 45,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child a rule breaker or never abides by any house/school rules?",
        "question_type": "text",
        "question_order": 46,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does he interrupt in a conversation without waiting for his turn?",
        "question_type": "text",
        "question_order": 47,
        "question_weight": 5.00,
        "question_category": "Hyperactive",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Is your child unable to sit still during calm activities or does he shift between activities?",
        "question_type": "text",
        "question_order": 48,
        "question_weight": 5.00,
        "question_category": "Behavioural Issue",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "ASD Survey Questions Of Shvesa Minds",
        "question_text": "Does he have habits like thumb sucking, nail biting, and hair twirling at a bothering level?",
        "question_type": "text",
        "question_order": 49,
        "question_weight": 5.00,
        "question_category": "Communication",
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Never",
                "option_weight": 1.00
            },
            {
                "option_text": "Rare",
                "option_weight": 2.00
            },
            {
                "option_text": "Sometimes",
                "option_weight": 3.00
            },
            {
                "option_text": "Often",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    }
]

export const ThreeYearChildQuestions = [
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "When you ask your child to point at the parts of the body, does she correctly point to at least five? She can point to the parts on herself, you, or a doll.",
        "question_type": "text",
        "question_order": 1,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child make sentences that are three or four words long? [REC]",
        "question_type": "text",
        "question_order": 2,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Without giving your child help by pointing or using gestures, ask him to 'put the book on the table'. Does your child carry out both directions correctly?",
        "question_type": "text",
        "question_order": 3,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "When looking at following pictures, does your child tell you what action is happening? Eg: eating, drinking, jumping, cooking, what the boy is doing? [REC]",
        "question_type": "text",
        "question_order": 4,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/0jOXe9R.jpeg"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "When you ask your child his name, will he be able to answer? [REC]",
        "question_type": "text",
        "question_order": 5,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Without holding onto anything for support, does your child kick a ball by swinging his leg forward?",
        "question_type": "text",
        "question_order": 6,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child jump with both feet leaving the floor at the same time?",
        "question_type": "text",
        "question_order": 7,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child walk upstairs? She may hold on to the railing or wall.",
        "question_type": "text",
        "question_order": 8,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Ask your child to draw a single line in a vertical direction? [WRITE]",
        "question_type": "text",
        "question_order": 9,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/dtm6pwT.jpeg"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Can your child string small items such as beads, macaroni, onto a string or shoelace?",
        "question_type": "text",
        "question_order": 10,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/kD6F5UA.jpeg"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Draw a single circle and ask him to make a circle like yours? [WRITE]",
        "question_type": "text",
        "question_order": 11,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/7jobs6o.jpeg"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child hold a pencil, crayon between her finger and thumb like an adult does?",
        "question_type": "text",
        "question_order": 12,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/KuFouOS.png"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Can your child make a single horizontal line from one side to the other side of paper? [WRITE]",
        "question_type": "text",
        "question_order": 13,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/6Me1H6s.png"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Can your child copy the following shape without tracing? [WRITE]",
        "question_type": "text",
        "question_order": 14,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/koRA9xI.png"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "If your child wants something he cannot reach, does he find a chair or box to stand on to reach it?",
        "question_type": "text",
        "question_order": 15,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "When looking in the mirror, ask where is [your child's name]? Does she point to her image in the mirror or say me or her name?",
        "question_type": "text",
        "question_order": 16,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [
            "https://i.imgur.com/6g1bXMK.jpeg"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "When you say 'five eight three' or any pair of numbers, does your child repeat just the three numbers in the same order? [REC]",
        "question_type": "text",
        "question_order": 17,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Using these exact words, ask your child, 'are you a girl or boy?', does your child answer correctly? [REC]",
        "question_type": "text",
        "question_order": 18,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child use a spoon to feed herself with little spilling?",
        "question_type": "text",
        "question_order": 19,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    },
    {
        "survey_title": "3 Years Development Assessment",
        "question_text": "Does your child use zip up and down?",
        "question_type": "text",
        "question_order": 20,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-16T12:00:00Z"
    }
]

export const FiveYearChildQuestions = [
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child tell you at least two things about common objects? [REC] E.g. If you ask about the ball, does he say something like, 'it's round. I throw it. It's big'?",
        "question_type": "text",
        "question_order": 21,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child use all the words in a sentence? E.g. 'I am going to the park', 'Is there a toy to play with'?",
        "question_type": "text",
        "question_order": 22,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child use endings of words such as '-s', '-ed', and '-ing'? [REC] E.g. playing, kicked, keys",
        "question_type": "text",
        "question_order": 23,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Without you giving help by pointing or repeating directions, can your child follow three unrelated directions? E.g. clap your hands, walk to the door, and sit down; or give me the pen, open the book, and stand up",
        "question_type": "text",
        "question_order": 24,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child use four or five word sentences? [REC]",
        "question_type": "text",
        "question_order": 25,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child use comparison words, such as 'heavier', 'stronger', or 'shorter'?",
        "question_type": "text",
        "question_order": 26,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child repeat sentences back to you without any mistakes? (Sentences will be read one at a time) E.g. 'Jane hides her shoes for Maria to find', 'Raj read the blue book under his bed' [REC]",
        "question_type": "text",
        "question_order": 27,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child hop up and down on either right foot or the left foot at least one time without losing her balance or falling?",
        "question_type": "text",
        "question_order": 28,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child jump forward a distance of 20 inches from a standing position, starting with her feet together?",
        "question_type": "text",
        "question_order": 29,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child throw a ball overhand (the child must raise his arms to shoulder height) in the direction of a person standing at least 6 feet away?",
        "question_type": "text",
        "question_order": 30,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/omuo0m5.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child catch a large ball with both hands?",
        "question_type": "text",
        "question_order": 31,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/M8NBY4w.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Without holding onto anything, does your child stand on one foot at least 5 seconds without losing her balance and putting her feet down?",
        "question_type": "text",
        "question_order": 32,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/3d6EhMV.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child copy at least three of the below shapes onto a large piece of paper using a pencil or crayon, without tracing? [WRITE]",
        "question_type": "text",
        "question_order": 33,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/3x1DlHT.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child unbutton one or more buttons? You may use his own clothing or a doll's clothing?",
        "question_type": "text",
        "question_order": 34,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child color mostly within the lines in a coloring book?",
        "question_type": "text",
        "question_order": 35,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Ask your child to color the following picture by copying the outline on a paper [WRITE]",
        "question_type": "text",
        "question_order": 36,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/6MjTpR4.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child trace on the line below with pencil, without going off the line more than two times?",
        "question_type": "text",
        "question_order": 37,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/q5gs1If.jpeg"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Ask your child to draw a picture of a person [boy or a girl]? [WRITE]",
        "question_type": "text",
        "question_order": 38,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child use scissors and cut a piece of paper in a straight line?",
        "question_type": "text",
        "question_order": 39,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "When shown objects and asked, 'what color is this?' does your child name five different colors like red, blue, yellow, orange, black and white?",
        "question_type": "text",
        "question_order": 40,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/AyNFp58.png", "https://i.imgur.com/9ZXzYAZ.png", "https://i.imgur.com/UkXzqBq.png",
            "https://i.imgur.com/vO4ayCu.jpeg", "https://i.imgur.com/jAjWlZ0.jpeg", "https://i.imgur.com/6aDTTWZ.png"
        ],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "If you place five objects in front of your child can he count them by saying 'one, two, three, four, five' in order?",
        "question_type": "text",
        "question_order": 41,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child point to the smallest circle in the following picture?",
        "question_type": "text",
        "question_order": 42,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/YfCJ5qm.png"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child count up to 15 without making mistakes?",
        "question_type": "text",
        "question_order": 43,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Ask your child to name the following numbers? [REC]",
        "question_type": "text",
        "question_order": 44,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/ZAaHmuY.png"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child copy the following letters without tracing? Cover up all the letters except the letter being copied. [WRITE]",
        "question_type": "text",
        "question_order": 45,
        "question_weight": 5.00,
        "option_type": "text",
        "images": ["https://i.imgur.com/jux44Gb.png"],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Write your child's name. Can your child copy the letters? The letters may be large, backward or reversed. [WRITE]",
        "question_type": "text",
        "question_order": 46,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child say the opposite words of the words italicized? For example, 'A rock is hard and a pillow is soft'. Write your child's response below: A cow is big and a mouse is ___. Ice is cold and fire is ___. We see stars at night, and we see the sun during ___. When I throw the ball up, it comes ___. [WRITE]",
        "question_type": "text",
        "question_order": 47,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Can your child serve himself, taking from one container to another using a spoon?",
        "question_type": "text",
        "question_order": 48,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child wash her hands using soap and water, and dry off with towel without help?",
        "question_type": "text",
        "question_order": 49,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child brush his teeth by putting toothpaste on toothbrush and brushing all his teeth without help?",
        "question_type": "text",
        "question_order": 50,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    },
    {
        "survey_title": "5 Years Development Assessment",
        "question_text": "Does your child dress and undress himself?",
        "question_type": "text",
        "question_order": 51,
        "question_weight": 5.00,
        "option_type": "text",
        "images": [],
        "options": [
            {
                "option_text": "Yes",
                "option_weight": 1.00
            },
            {
                "option_text": "No",
                "option_weight": 4.00
            }
        ],
        "created_at": "2024-12-18T12:00:00Z"
    }
]